import React from 'react'
import logo from '../assets/thryv-logo.svg'
import styled from '@emotion/styled'
import {BlueGradientBackground} from './AuthForm'

export const ScreenContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(83, 120, 252, 0.2713877787443102) 9%,
    rgba(255, 80, 0, 0.2713877787443102) 50%
  );
  .container {
    border: 1px solid #aaaaaa;
    width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: white;
    padding: 20px 10px;
  }
`

const NotFoundForm = ({message}) => {
  const displayMessage =
    message || 'The page you are looking for cannot be found.'

  return (
    <>
      <BlueGradientBackground></BlueGradientBackground>
      <section
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <div
          style={{
            background: 'white',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '14px 55px',
            borderRadius: '10px',
            boxShadow: '0px 2px 4px 0px #00000040',
            maxWidth: '600px',
            marginInline: '20px',
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{
              width: '160px',
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          />
          <h2>{displayMessage}</h2>
        </div>
      </section>
    </>
  )
}

export default NotFoundForm
